import type { Bcp47Locale } from '@backmarket/core-types/Locale'

import type { BrowsingHistoryKind } from '../types'

const COMBINING_DIACRITICS = /[\u0300-\u036f]/g
const WHITESPACE = /\s/u

export function normalizeTerm(term: string): string {
  return term
    .normalize('NFD')
    .replace(COMBINING_DIACRITICS, '')
    .toLowerCase()
    .split(WHITESPACE)
    .filter(Boolean)
    .join(' ')
}

export function normalizePath(path: string): string {
  return path.split('#')[0].split('?')[0]
}

export function buildEntryId(
  kind: BrowsingHistoryKind,
  locale: Bcp47Locale,
  reference: string,
): string {
  return `${kind}:${locale}:${reference}`
}
